import React, { useState, useEffect, useRef, useCallback } from "react";
import { Spinner, SpinnerSize, Pivot, PivotItem, MessageBarType } from '@fluentui/react';
import SingleQARTask from "./SingleQARTask";
import OwnerSearch from "./OwnerSearch";
import Api from '../../services/Api';
import axios from 'axios';
import PageNavi from "../Administration/PageNavi";
import { Stack } from '@fluentui/react';
import DeliveryCenterButton from "./DeliveryCenterButton";
import MySitesTabs from "./MySitesTabs";
import MyTeamsTabs from "./MyTeamsTabs";
import MyGroups from "./MyGroups";
import MyCharges from "./MyCharges";
import MyPowerPlatform from "./MyPowerPlatform";
import RequestLicenseTask from "./RequestLicenseTask";
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl, getUrlParams, removeUrlParam } from "../../helpers/HelperMethods";
import DemandRequestButton from "./DemandRequestButton";
import TeamsLiveCollaborationButton from "./TeamsLiveCollaborationButton";
import PowerPlatformHubButton from "./PowerPlatformHubButton";
import MyTasks from "./MyTasks";
import UserGuidesTabs from '../Settings/UserGuidesTabs';
import EditModal from "../EditSite/EditModal";
import { addMessageBar } from "../../actions/appActions";
import { connect } from 'react-redux';


const initialResultsSlice = {
    results: [],
    totalCount: 0,
    page: 1,
    onPage: 100
};

const initialState = {
    isLoading: {
        ownedSites: true,
        coOwnedSites: true,
        ownedTeams: true,
        coOwnedTeams: true,
        groups: true,
        charges: true,
        newSites: true,
        changes: true,
        qars: true,
        powerApps: true,
        flows: true,
        powerAppSolutions: true,
        licenseTasks: false,
        powerAppEnvironments: true,
        aiBuilderCreditsUsage: true,
        copilotCreditsUsage: true
    },
    ownedSites: { ...initialResultsSlice },
    coOwnedSites: { ...initialResultsSlice },
    ownedTeams: { ...initialResultsSlice },
    coOwnedTeams: { ...initialResultsSlice },
    groups: { ...initialResultsSlice },
    charges: { ...initialResultsSlice },
    newSites: { results: [] },
    aiBuilderCreditsUsage: [],
    copilotCreditsUsage: [],
    licenseTasks: [],
    changes: [],
    changeTypes: null,
    changeTypesLoaded: false,
    qars: [],
    powerApps: { ...initialResultsSlice },
    flows: { ...initialResultsSlice },
    powerAppSolutions: { ...initialResultsSlice },
    powerAppEnvironments: { ...initialResultsSlice },
    isNotificationOnly: false,
    qarTasksToRefresh: false,
    error: false,
    powerAppChanges: [],
    powerAppSolutionChanges: [],
    powerAppEnvironmentChanges: [],
    powerAppSolutionId: null
};

function ManageCenterContent(props) {
    const [state, setState] = useState(initialState);

    // Mirrors the latest state synchronously so callbacks (API responses,
    // handlers) never read a stale closure - equivalent to reading
    // `this.state` inside a class component.
    const stateRef = useRef(state);
    stateRef.current = state;

    const axiosCancelSourceRef = useRef(null);
    const isFirstRender = useRef(true);

    const getItems = useCallback((filterBy, results, endpoint = 'SitesPanel', queryString = '') => {
        setState(prevState => ({
            ...prevState,
            isLoading: {
                ...prevState.isLoading,
                [results]: true
            }
        }));

        let url = `/${endpoint}?filterBy=${filterBy}${queryString ? `&${queryString}` : ''}`;
        const currentSlice = stateRef.current[results];
        if (currentSlice && currentSlice.page) {
            url += `&page=${currentSlice.page}&onPage=${currentSlice.onPage}`;
        }

        Api.get(url, {
            cancelToken: axiosCancelSourceRef.current.token
        })
        .then(res => res.data)
        .then(sitesResults => {
            setState(prevState => ({
                ...prevState,
                isLoading: {
                    ...prevState.isLoading,
                    [results]: false
                },
                [results]: {
                    ...prevState[results],
                    ...sitesResults
                }
            }));
        })
        .catch(error => {
            setState(prevState => ({ ...prevState, isLoading: { ...prevState.isLoading, [results]: false }}));
            console.log(error);
        });
    }, []);

    const getChangeTasks = useCallback((filterBy, results, endpoint) => {
        setState(prevState => ({
            ...prevState,
            isLoading: {
                ...prevState.isLoading,
                [results]: true
            }
        }));

        Api.get(`/${endpoint}?filterBy=${filterBy}&includeChangeDbObject=true`, {
            cancelToken: axiosCancelSourceRef.current.token
        })
        .then(res => res.data)
        .then(tasks => {
            setState(prevState => ({
                ...prevState,
                isLoading: {
                    ...prevState.isLoading,
                    [results]: false
                },
                [results]: tasks
            }));
        })
        .catch(error => {
            setState(prevState => ({ ...prevState, isLoading: { ...prevState.isLoading, [filterBy]: false }}));
            console.log(error);
        });
    }, []);

    const getQARTasks = useCallback((filterBy) => {
        setState(prevState => ({
            ...prevState,
            isLoading: {
                ...prevState.isLoading,
                qars: true
            }
        }));

        Api.get(`/QARTasks?filterBy=${filterBy}`, {
            cancelToken: axiosCancelSourceRef.current.token
        })
        .then(res => res.data)
        .then(sites => {
            setState(prevState => ({
                ...prevState,
                isLoading: {
                    ...prevState.isLoading,
                    qars: false
                },
                qars: sites
            }));
        })
        .catch(error => {
            setState(prevState => ({ ...prevState, isLoading: { ...prevState.isLoading, [filterBy]: false }}));
            console.log(error);
        });
    }, []);

    const getLicenseTasks = useCallback((filterBy) => {
        setState(prevState => ({
            ...prevState,
            isLoading: {
                ...prevState.isLoading,
                licenseTasks: true
            }
        }));

        Api.get(`/RequestLicenseTasks?filterBy=${filterBy}`, {
            cancelToken: axiosCancelSourceRef.current.token
        })
        .then(res => res.data)
        .then(tasks => {
            setState(prevState => ({
                ...prevState,
                isLoading: {
                    ...prevState.isLoading,
                    licenseTasks: false
                },
                licenseTasks: tasks
            }));
        })
        .catch(error => {
            setState(prevState => ({
                ...prevState,
                isLoading: {
                    ...prevState.isLoading,
                    [filterBy]: false
                }
            }));
            console.log(error);
        });
    }, []);

    // eslint-disable-next-line no-unused-vars
    const getChangeTypes = useCallback(() => {
        Api.get(`/ChangeType?p=1`, {
            cancelToken: axiosCancelSourceRef.current.token
        })
        .then(res => res.data)
        .then(sites => {
            setState(prevState => ({
                ...prevState,
                changeTypes: sites,
                changeTypesLoaded: true,
            }));
        })
        .catch(error => {
            console.log(error);
        });
    }, []);

    const getCreditsUsage = useCallback((results, endpoint) => {
        setState(prevState => ({
            ...prevState,
            isLoading: {
                ...prevState.isLoading,
                [results]: true
            }
        }));

        let url = `/${endpoint}`;
        const currentSlice = stateRef.current[results];
        if (currentSlice && currentSlice.page) {
            url += `?page=${currentSlice.page}&onPage=${currentSlice.onPage}`;
        }

        Api.get(url, {
            cancelToken: axiosCancelSourceRef.current.token
        })
        .then(res => res.data)
        .then(data => {
            setState(prevState => ({
                ...prevState,
                isLoading: {
                    ...prevState.isLoading,
                    [results]: false
                },
                [results]: data
            }));
        })
        .catch(error => {
            setState(prevState => ({ ...prevState, isLoading: { ...prevState.isLoading, [results]: false }}));
            console.log(error);
        });
    }, []);

    const downloadData = useCallback(() => {
        //getChangeTypes();
        getItems('sitesOwner', 'ownedSites');
        getItems('sitesCoOwner', 'coOwnedSites');
        getItems('teamsOwner', 'ownedTeams');
        getItems('teamsCoOwner', 'coOwnedTeams');
        getItems('groupsOwner', 'groups');
        getItems('charges', 'charges');
        getItems('approver', 'newSites');
        getChangeTasks('approver', 'changes', 'ApproverTasks');
        getChangeTasks('approver', 'powerAppChanges', 'PowerAppChangeTask');
        getChangeTasks('approver', 'powerAppSolutionChanges', 'PowerAppSolutionChangeTask');
        getChangeTasks('approver', 'powerAppEnvironmentChanges', 'PowerAppEnvironmentChangeTask');
        getQARTasks('approver');
        getLicenseTasks('approver');
        getItems('owner', 'powerApps', 'PowerAppsPanel', `type=powerApp&fromSolutions=false`);
        getItems('owner', 'flows', 'PowerAppsPanel', `type=flow&fromSolutions=false`);
        getItems('owner', 'powerAppSolutions', 'PowerAppSolutionsPanel', 'isTileView=true&getSupportingSolutions=false');
        getItems('owner', 'powerAppEnvironments', 'EnvironmentsPanel');
        getCreditsUsage('aiBuilderCreditsUsage', 'Charges/AiBuilderCreditsUsage');
        getCreditsUsage('copilotCreditsUsage', 'Charges/CopilotCreditsUsage');
    }, [getItems, getChangeTasks, getQARTasks, getLicenseTasks, getCreditsUsage]);

    const refresh = useCallback(() => {
        downloadData();
    }, [downloadData]);

    // componentDidMount / componentWillUnmount
    useEffect(() => {
        axiosCancelSourceRef.current = axios.CancelToken.source();

        downloadData();

        return () => {
            axiosCancelSourceRef.current.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // componentDidUpdate: refresh when qarTasksToRefresh changes (but not on mount)
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.qarTasksToRefresh]);

    // Side effect that used to live inline in render(): warn about AI Builder
    // usage detected in flows once both usage endpoints have loaded.
    useEffect(() => {
        if (!state.isLoading.aiBuilderCreditsUsage && !state.isLoading.copilotCreditsUsage) {
            if (state.aiBuilderCreditsUsage.some(x => x.flow) || state.copilotCreditsUsage.some(x => x.flow)) {
                props.addMessageBar(
                    '/ManageCenter#MyPowerPlatform/MyFlows',
                    MessageBarType.warning,
                    'An AI Builder action has been detected in one of your flows (based on activity in the last 3 months), which may incur additional costs. Check the IS Chargers tab for consumption and environment details.'
                );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.isLoading.aiBuilderCreditsUsage, state.isLoading.copilotCreditsUsage, state.aiBuilderCreditsUsage, state.copilotCreditsUsage]);

    const getObjectById = useCallback(async (id, endpoint) => {
        const result = await Api.get(`/${endpoint}?id=${id}`);
        return result.data;
    }, []);

    const onEditCallback = useCallback(async (id, data, endpoint) => {
        const site = await getObjectById(id, endpoint);

        setState(prevState => {
            const items = prevState[data].results;
            const updatedItems = items.map(x => (x.id === id) ? site : x);

            return {
                ...prevState,
                [data]: { ...prevState[data], results: updatedItems }
            };
        });
    }, [getObjectById]);

    const onGetCallback = useCallback((value, data) => {
        setState(prevState => {
            const items = prevState[data].results;
            const updatedItems = items.map(x => (x.id === value.id) ? value : x);

            return {
                ...prevState,
                [data]: {
                    ...prevState[data],
                    results: updatedItems
                }
            };
        });
    }, []);

    const getQarTaskFromUrl = () => {
        const qarTaskId = getUrlParams("qarTaskId");
        return qarTaskId ? state.qars.find(x => x.id === Number(qarTaskId)) : null;
    };

    const getLicenseTaskFromUrl = () => {
        const taskId = getUrlParams("licenseTaskId");
        return taskId ? state.licenseTasks.find(x => x.id === Number(taskId)) : null;
    };

    // eslint-disable-next-line no-unused-vars
    const getPowerAppTaskFromUrl = () => {
        const powerAppTaskId = getUrlParams('powerAppTaskId');
        return powerAppTaskId ? state.powerAppChanges.find(x => x.id === Number(powerAppTaskId)) : null;
    };

    // eslint-disable-next-line no-unused-vars
    const getPowerAppSolutionTaskFromUrl = () => {
        const powerAppSolutionTaskId = getUrlParams('powerAppSolutionTaskId');
        return powerAppSolutionTaskId ? state.powerAppSolutionChanges.find(x => x.id === Number(powerAppSolutionTaskId)) : null;
    };

    const setPageUrlFilter = useCallback((results, filterBy, value, endpoint, query = '') => {
        setState(prevState => ({
            ...prevState,
            [results]: {
                ...prevState[results],
                page: value
            }
        }));
        // getItems reads the page straight off stateRef, but stateRef won't
        // reflect the update above until after this render commits, so pass
        // the endpoint/query through and let getItems read the *new* page
        // via a microtask-safe ref update performed right here.
        stateRef.current = {
            ...stateRef.current,
            [results]: {
                ...stateRef.current[results],
                page: value
            }
        };
        getItems(filterBy, results, endpoint, query);
    }, [getItems]);

    const getPageNavi = (results, filterBy, endpoint, query = '') => {
        return state[results].totalCount > state[results].onPage &&
            <div style={{ flexBasis: '100%' }}>
                <PageNavi
                    pageNumPart={(value) => setPageUrlFilter(results, filterBy, value, endpoint, query)}
                    resultsOnPage={state[results].onPage}
                    pageNum={state[results].page}
                    totalResults={state[results].totalCount}
                />
            </div>;
    };

    const bulkApproveQARTasks = useCallback(() => {
        setState(prevState => ({ ...prevState, error: false, qarTasksToRefresh: false }));

        Api.post('/BulkApproveQARTasks', {})
            .then(res => res.data)
            .then(post => {
                if (post === 200) {
                    setState(prevState => ({ ...prevState, qarTasksToRefresh: true }));
                } else {
                    setState(prevState => ({ ...prevState, error: true }));
                }
            })
            .catch((error) => {
                setState(prevState => ({ ...prevState, error: true }));
                console.log(error);
            });
    }, []);

    const onFilterToggleChange = useCallback((filterBy, results, endpoint, query) => {
        setState(prevState => ({
            ...prevState,
            [results]: {
                ...prevState[results],
                page: 1,
            }
        }));
        stateRef.current = {
            ...stateRef.current,
            [results]: {
                ...stateRef.current[results],
                page: 1
            }
        };
        getItems(filterBy, results, endpoint, query);
    }, [getItems]);

    const onShowPowerAppSolutionModal = useCallback((id) => {
        setState(prevState => ({ ...prevState, powerAppSolutionId: id }));
    }, []);

    const sitesTotal = () => {
        const ownedSitesTotal = state.ownedSites.totalCount > 0 ? state.ownedSites.totalCount : 0;
        const coOwnedSitesTotal = state.coOwnedSites.totalCount > 0 ? state.coOwnedSites.totalCount : 0;
        return ownedSitesTotal + coOwnedSitesTotal;
    };

    const teamsTotal = () => {
        const ownedTeamsTotal = state.ownedTeams.totalCount > 0 ? state.ownedTeams.totalCount : 0;
        const coOwnedTeamsTotal = state.coOwnedTeams.totalCount > 0 ? state.coOwnedTeams.totalCount : 0;
        return ownedTeamsTotal + coOwnedTeamsTotal;
    };

    const groupsTotal = () => {
        return state.groups.totalCount > 0 ? state.groups.totalCount : 0;
    };

    const chargesTotal = () => {
        return state.charges.totalCount + state.aiBuilderCreditsUsage.length + state.copilotCreditsUsage.length;
    };

    const qarTask = getQarTaskFromUrl();
    const qarTaskDialog = qarTask &&
        <SingleQARTask
            key={qarTask.id + qarTask.label}
            element={qarTask}
            showDialog={true}
            refresh={refresh}
        />;

    const licenseTask = getLicenseTaskFromUrl();
    const licenseTaskDialog = licenseTask &&
        <RequestLicenseTask
            key={licenseTask.id}
            task={licenseTask}
            refresh={refresh}
            showDialog={true}
        />;

    const powerAppId = getUrlParams('powerAppId');
    const powerAppDialog = powerAppId &&
        <EditModal
            itemId={powerAppId}
            isModalOpened={true}
            isEditable={true}
            isPowerApp={true}
            onCloseModal={removeUrlParam}
            showSolutionModal={onShowPowerAppSolutionModal}
        />;

    const powerAppSolutionId = getUrlParams('powerAppSolutionId');
    const powerAppSolutionDialog =
        (powerAppSolutionId &&
            <EditModal
                itemId={powerAppSolutionId}
                isModalOpened={true}
                isEditable={true}
                isPowerAppSolution={true}
                onCloseModal={removeUrlParam}
            />
        ) ||
        (state.powerAppSolutionId &&
            <EditModal
                itemId={state.powerAppSolutionId}
                isModalOpened={true}
                isEditable={true}
                isPowerAppSolution={true}
                onCloseModal={() => setState(prevState => ({ ...prevState, powerAppSolutionId: null }))}
            />
        );

    const powerAppEnvironmentId = getUrlParams('powerAppEnvironmentId');
    const powerAppEnvironmentDialog = powerAppEnvironmentId &&
        <EditModal
            itemId={powerAppEnvironmentId}
            isModalOpened={true}
            isEditable={true}
            isPowerAppEnvironment={true}
            onCloseModal={removeUrlParam}
        />;

    const ownedSitesPageNavi = getPageNavi('ownedSites', 'sitesOwner');
    const coOwnedSitesPageNavi = getPageNavi('coOwnedSites', 'sitesCoOwner');
    const ownedTeamsPageNavi = getPageNavi('ownedTeams', 'teamsOwner');
    const coOwnedTeamsPageNavi = getPageNavi('coOwnedTeams', 'teamsCoOwner');
    const groupsPageNavi = getPageNavi('groups', 'groupsOwner');
    const chargesPageNavi = getPageNavi('charges', 'charges');

    const defaultSelectedKey = getPivotItemKeyFromUrl('MyTasks');
    const spinner = <Spinner style={{ margin: '200px' }} size={SpinnerSize.large} />;

    const isTasksLoading = state.isLoading.newSites || state.isLoading.changes || state.isLoading.qars ||
        state.isLoading.licenseTasks || state.isLoading.powerAppChanges ||
        state.isLoading.powerAppSolutionChanges || state.isLoading.powerAppEnvironmentChanges;

    return (
        <div style={{ backgroundColor: '#F8F8F8', minHeight: '500px', padding: '20px 20px 20px 20px' }}>
            {qarTaskDialog}
            {licenseTaskDialog}
            {powerAppDialog}
            {powerAppSolutionDialog}
            {powerAppEnvironmentDialog}
            <Stack horizontal reversed>
            </Stack>
            <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey} onLinkClick={addPivotItemKeyToUrl()}>
                <PivotItem itemKey='MySites' headerText='My SharePoint Sites'
                    itemCount={state.isLoading.ownedSites || state.isLoading.coOwnedSites ? undefined : sitesTotal()}>
                    {
                        <div style={pivotItemStyles}>
                            <MySitesTabs
                                parentPivotKey='MySites'
                                isLoadingOwnedSites={state.isLoading.ownedSites}
                                isLoadingcoOwnedSites={state.isLoading.coOwnedSites}
                                ownedSites={state.ownedSites}
                                coOwnedSites={state.coOwnedSites}
                                ownedSitesPageNavi={ownedSitesPageNavi}
                                coOwnedSitesPageNavi={coOwnedSitesPageNavi}
                                editCallback={onEditCallback}
                            />
                        </div>
                    }
                    <DemandRequestButton />
                    <DeliveryCenterButton />
                </PivotItem>
                <PivotItem itemKey='MyTeams' headerText='My Teams'
                    itemCount={state.isLoading.ownedTeams || state.isLoading.coOwnedTeams ? undefined : teamsTotal()}>
                    {
                        <div style={pivotItemStyles}>
                            <MyTeamsTabs
                                parentPivotKey='MyTeams'
                                isLoadingOwnedTeams={state.isLoading.ownedTeams}
                                isLoadingcoOwnedTeams={state.isLoading.coOwnedTeams}
                                ownedTeams={state.ownedTeams}
                                coOwnedTeams={state.coOwnedTeams}
                                ownedTeamsPageNavi={ownedTeamsPageNavi}
                                coOwnedTeamsPageNavi={coOwnedTeamsPageNavi}
                                editCallback={onEditCallback}
                            />
                        </div>
                    }
                    <DemandRequestButton />
                    <TeamsLiveCollaborationButton />
                </PivotItem>
                <PivotItem itemKey='MyGroups' headerText='My Groups'
                    itemCount={state.isLoading.groups ? undefined : groupsTotal()}>
                    {
                        state.isLoading.groups ? spinner
                            :
                            <div style={pivotItemStyles}>
                                <MyGroups
                                    groups={state.groups.results}
                                />
                                {groupsPageNavi}
                            </div>
                    }
                    <DemandRequestButton />
                    <DeliveryCenterButton />
                </PivotItem>
                <PivotItem itemKey='MyCharges' headerText='My Charges'
                    itemCount={state.isLoading.charges || state.isLoading.aiBuilderCreditsUsage || state.isLoading.copilotCreditsUsage ? undefined : chargesTotal()}>
                    {
                        state.isLoading.charges || state.isLoading.aiBuilderCreditsUsage || state.isLoading.copilotCreditsUsage
                            ? spinner
                            :
                            <div style={pivotItemStyles}>
                                <MyCharges
                                    sites={state.charges.results}
                                    aiBuilderCreditsUsage={state.aiBuilderCreditsUsage}
                                    copilotCreditsUsage={state.copilotCreditsUsage}
                                />
                                {chargesPageNavi}
                            </div>
                    }
                    <DemandRequestButton />
                    <DeliveryCenterButton />
                </PivotItem>
                <PivotItem itemKey='MyPowerPlatform' headerText='My PowerPlatform'
                    itemCount={(state.powerApps.allTotalCount === undefined || state.flows.allTotalCount === undefined || state.powerAppSolutions.allTotalCount === undefined || state.powerAppEnvironments.allTotalCount === undefined)
                        ? undefined
                        : state.powerApps.allTotalCount + state.flows.allTotalCount + state.powerAppSolutions.allTotalCount + state.powerAppEnvironments.allTotalCount}>
                    <MyPowerPlatform
                        apps={state.powerApps}
                        flows={state.flows}
                        solutions={state.powerAppSolutions}
                        environments={state.powerAppEnvironments}
                        getCallback={onGetCallback}
                        getPageNavi={getPageNavi}
                        isLoading={state.isLoading}
                        parentPivotKey='MyPowerPlatform'
                        onFilterToggleChange={onFilterToggleChange}
                    />
                    <PowerPlatformHubButton />
                </PivotItem>
                <PivotItem itemKey='MyTasks' headerText='My Tasks' itemCount={isTasksLoading ? undefined : (state.newSites.results.length + state.changes.length + state.qars.length + state.licenseTasks.length + state.powerAppChanges.length + state.powerAppSolutionChanges.length + state.powerAppEnvironmentChanges.length)}>
                    <MyTasks
                        newSitesTasks={state.newSites.results}
                        changeSiteTasks={state.changes}
                        licenseTasks={state.licenseTasks}
                        qarTasks={state.qars}
                        powerAppChanges={state.powerAppChanges}
                        powerAppSolutionChanges={state.powerAppSolutionChanges}
                        powerAppEnvironmentChanges={state.powerAppEnvironmentChanges}
                        bulkApproveQARTasks={bulkApproveQARTasks}
                        isTasksLoading={isTasksLoading}
                        refresh={refresh}
                        getCallback={onGetCallback}
                    />
                    <DemandRequestButton />
                    <DeliveryCenterButton />
                </PivotItem>
                <PivotItem itemKey='OwnerSearch' headerText='Administrator search'>
                    <OwnerSearch />
                    <DemandRequestButton />
                    <DeliveryCenterButton />
                </PivotItem>
                <PivotItem itemKey='UserGuides' headerText='User Guides'>
                    <UserGuidesTabs parentPivotKey='UserGuides' adminEditMode={false} />
                    <DemandRequestButton />
                    <DeliveryCenterButton />
                </PivotItem>
            </Pivot>
        </div>
    );
}

const pivotStyles = {
    root: {
        marginBottom: 20,
        whiteSpace: 'pre-wrap',
        //maxWidth: 'calc(100% - 450px)',
        //minWidth: 300
    },
    linkContent: {
        fontSize: 16,
        flex: 'auto'
    }
}

const pivotItemStyles = {
    display: 'flex',
    flexWrap: 'wrap',
    width: "100%"
}


const mapActionsToProps = {
    addMessageBar,
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps, mapActionsToProps)(ManageCenterContent)


// WEBPACK FOOTER //
// ./src/components/ManageCenter/ManageCenterContent.js